import { render } from "./PresupuestoList.vue?vue&type=template&id=8af83b8e"
import script from "./PresupuestoList.vue?vue&type=script&lang=js"
export * from "./PresupuestoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__